import Plyr from 'plyr';
import Alpine from 'alpinejs';
import VideoPlayer from '../interfaces/VideoPlayer';

export default function initInfoVideo() {
  Alpine.data(
    'infoVideo',
    (): VideoPlayer => ({
      player: null,
      isPlaying: false,
      playerElement: null,
      modalId: null,
      videoId: null,
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent || ''),
      init() {
        document.addEventListener('DOMContentLoaded', () => {
          if (!window.verifyCookies || window.verifyCookies()) {
            this.initVideo();
          }
        });
      },
      initVideo() {
        // @ts-ignore
        this.playerElement = this.$el.querySelector('.plyr__video-embed');
        this.player = null;
        this.isPlaying = false;
      },
      onToggle() {
        if (this.isIOS) {
          this.openInYT();
        } else if (!this.player) {
          this.createIframe();
        } else {
          this.toggleStatus();
        }
      },
      createIframe() {
        if (this.playerElement) {
          const { videoId } = this.playerElement.dataset;
          const iframeEl = document.createElement('iframe');
          iframeEl.dataset.consent = 'analytics';
          // eslint-disable-next-line @stylistic/max-len
          iframeEl.dataset.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1controls=0&enablejsapi=1&mute=1&loop=1&playlist=${videoId}&origin=${window.location.origin}`;
          // eslint-disable-next-line @stylistic/max-len
          iframeEl.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&controls=0&enablejsapi=1&mute=1&loop=1&playlist=${videoId}&origin=${window.location.origin}`;
          iframeEl.setAttribute('allowfullscreen', '');
          iframeEl.setAttribute('allow', 'autoplay');
          iframeEl.title = 'Play video';
          iframeEl.loading = 'lazy';
          iframeEl.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms');

          this.playerElement.appendChild(iframeEl);
          this.initVideoPlayer();
        }
      },
      toggleStatus() {
        if (this.isPlaying) {
          this.pause();
        } else {
          this.play();
        }
      },
      play() {
        if (this.player) {
          this.player.play();
          this.isPlaying = true;
        }
      },
      pause() {
        if (this.player) {
          this.player.pause();
          this.isPlaying = false;
        }
      },
      async initVideoPlayer() {
        if (this.playerElement) {
          const { ratio, controls } = this.playerElement.dataset;
          this.player = new Plyr(this.playerElement, {
            controls: controls ? controls.split('|') : [],
            ratio: ratio ?? '16:9',
            youtube: {
              noCookie: true,
              rel: 0,
              modestbranding: 1,
              showInfo: false,
            },
          });
          if (this.player) {
            this.player.on('ready', () => {
              setTimeout(() => {
                if (this.player) {
                  this.player.play();
                  this.isPlaying = true;
                }
              }, 50);
            });
          }
        }
      },
      openInYT() {
        if (this.playerElement) {
          const { videoId } = this.playerElement.dataset;
          if (videoId) {
            window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
          }
        }
      },
    }),
  );
}
